// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/.pnpm/css-loader@7.1.4_webpack@5.105.4/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dp-save-template h3 {
  margin: 0 0 var(--dp-spacing-xs);
  font-size: var(--dp-font-size-md);
  color: var(--dp-color-text);
}

.dp-save-template__desc {
  font-size: var(--dp-font-size-xs);
  color: var(--dp-color-text-secondary);
  margin: 0 0 var(--dp-spacing-md);
}

.dp-save-template__form {
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-md);
  margin-bottom: var(--dp-spacing-md);
}

.dp-save-template__form label {
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  color: var(--dp-color-text);
  display: flex;
  flex-direction: column;
  gap: var(--dp-spacing-xs);
}

.dp-save-template__form input,
.dp-save-template__form textarea {
  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);
  border: var(--dp-border-width-thin) solid var(--dp-color-border);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-sm);
  font-family: inherit;
}

.dp-save-template__form textarea { resize: vertical; }

.dp-save-template__btn {
  width: 100%;
  padding: var(--dp-spacing-sm);
  background: var(--dp-color-primary);
  color: var(--dp-color-text-inverse);
  border: none;
  border-radius: var(--dp-border-radius-md);
  font-weight: var(--dp-font-weight-semibold);
  cursor: pointer;
}

.dp-save-template__btn:disabled { opacity: 0.5; }

.dp-save-template__message {
  margin-top: var(--dp-spacing-md);
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
}

.dp-save-template__message--success { background: #e8f5e9; color: #2e7d32; }
.dp-save-template__message--error { background: #fde8e8; color: #c62828; }

/* Inline note shown above the new-template form when the user pivoted
 * from an existing binding into "Save as new". Visually separates the
 * fork context from the form fields so the user knows what's happening. */
.dp-save-template__forknote {
  background: #fff7ed;
  border: 1px solid #fed7aa;
  color: #9a3412;
  padding: var(--dp-spacing-sm);
  border-radius: var(--dp-border-radius-sm);
  font-size: var(--dp-font-size-xs);
  line-height: 1.45;
  margin-bottom: var(--dp-spacing-md);
}

/* Subtle text-only button used for secondary actions (cancel, "save as new
 * instead", etc.). Lives inline with body text — never use a filled button
 * for these or it competes with the primary action. */
.dp-save-template__linkbtn {
  display: inline-block;
  background: transparent;
  border: none;
  color: var(--dp-color-primary);
  font-size: var(--dp-font-size-xs);
  font-weight: var(--dp-font-weight-semibold);
  padding: 4px 0;
  margin-top: 4px;
  cursor: pointer;
  text-decoration: underline;
}
.dp-save-template__linkbtn:hover { opacity: 0.8; }
`, "",{"version":3,"sources":["webpack://./src/taskpane/components/SaveTemplate.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,2BAA2B;AAC7B;;AAEA;EACE,iCAAiC;EACjC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mCAAmC;AACrC;;AAEA;EACE,iCAAiC;EACjC,2CAA2C;EAC3C,2BAA2B;EAC3B,aAAa;EACb,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;EAEE,kDAAkD;EAClD,gEAAgE;EAChE,yCAAyC;EACzC,iCAAiC;EACjC,oBAAoB;AACtB;;AAEA,mCAAmC,gBAAgB,EAAE;;AAErD;EACE,WAAW;EACX,6BAA6B;EAC7B,mCAAmC;EACnC,mCAAmC;EACnC,YAAY;EACZ,yCAAyC;EACzC,2CAA2C;EAC3C,eAAe;AACjB;;AAEA,kCAAkC,YAAY,EAAE;;AAEhD;EACE,gCAAgC;EAChC,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA,sCAAsC,mBAAmB,EAAE,cAAc,EAAE;AAC3E,oCAAoC,mBAAmB,EAAE,cAAc,EAAE;;AAEzE;;0EAE0E;AAC1E;EACE,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;EACd,6BAA6B;EAC7B,yCAAyC;EACzC,iCAAiC;EACjC,iBAAiB;EACjB,mCAAmC;AACrC;;AAEA;;sDAEsD;AACtD;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,8BAA8B;EAC9B,iCAAiC;EACjC,2CAA2C;EAC3C,cAAc;EACd,eAAe;EACf,eAAe;EACf,0BAA0B;AAC5B;AACA,mCAAmC,YAAY,EAAE","sourcesContent":[".dp-save-template h3 {\n  margin: 0 0 var(--dp-spacing-xs);\n  font-size: var(--dp-font-size-md);\n  color: var(--dp-color-text);\n}\n\n.dp-save-template__desc {\n  font-size: var(--dp-font-size-xs);\n  color: var(--dp-color-text-secondary);\n  margin: 0 0 var(--dp-spacing-md);\n}\n\n.dp-save-template__form {\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-md);\n  margin-bottom: var(--dp-spacing-md);\n}\n\n.dp-save-template__form label {\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  color: var(--dp-color-text);\n  display: flex;\n  flex-direction: column;\n  gap: var(--dp-spacing-xs);\n}\n\n.dp-save-template__form input,\n.dp-save-template__form textarea {\n  padding: var(--dp-spacing-xs) var(--dp-spacing-sm);\n  border: var(--dp-border-width-thin) solid var(--dp-color-border);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-sm);\n  font-family: inherit;\n}\n\n.dp-save-template__form textarea { resize: vertical; }\n\n.dp-save-template__btn {\n  width: 100%;\n  padding: var(--dp-spacing-sm);\n  background: var(--dp-color-primary);\n  color: var(--dp-color-text-inverse);\n  border: none;\n  border-radius: var(--dp-border-radius-md);\n  font-weight: var(--dp-font-weight-semibold);\n  cursor: pointer;\n}\n\n.dp-save-template__btn:disabled { opacity: 0.5; }\n\n.dp-save-template__message {\n  margin-top: var(--dp-spacing-md);\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n}\n\n.dp-save-template__message--success { background: #e8f5e9; color: #2e7d32; }\n.dp-save-template__message--error { background: #fde8e8; color: #c62828; }\n\n/* Inline note shown above the new-template form when the user pivoted\n * from an existing binding into \"Save as new\". Visually separates the\n * fork context from the form fields so the user knows what's happening. */\n.dp-save-template__forknote {\n  background: #fff7ed;\n  border: 1px solid #fed7aa;\n  color: #9a3412;\n  padding: var(--dp-spacing-sm);\n  border-radius: var(--dp-border-radius-sm);\n  font-size: var(--dp-font-size-xs);\n  line-height: 1.45;\n  margin-bottom: var(--dp-spacing-md);\n}\n\n/* Subtle text-only button used for secondary actions (cancel, \"save as new\n * instead\", etc.). Lives inline with body text — never use a filled button\n * for these or it competes with the primary action. */\n.dp-save-template__linkbtn {\n  display: inline-block;\n  background: transparent;\n  border: none;\n  color: var(--dp-color-primary);\n  font-size: var(--dp-font-size-xs);\n  font-weight: var(--dp-font-weight-semibold);\n  padding: 4px 0;\n  margin-top: 4px;\n  cursor: pointer;\n  text-decoration: underline;\n}\n.dp-save-template__linkbtn:hover { opacity: 0.8; }\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
